import React, { useEffect} from "react";
import useState from 'react-usestateref';
import "../index.css";
import {
  uploadFilePath,
  listOfFileNamesPageDir,
} from "../authorization/FetchToken";

import Navbar from "../components/Navbar";
import FileTree from "../fileTree";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Button,
  Input,
  Divider,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  CircularProgress,
  Paper,
  Stack,
  Alert
} from "@mui/material";

import {
  CloudUpload,
} from "@mui/icons-material";

import RefreshIcon from "@mui/icons-material/Refresh";
import { useAuth } from './AuthContext';
import InfoTip from "../components/InfoTip";
import {IconButton} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ReactMarkdown from "react-markdown";
import Drawer from "@mui/material/Drawer";
import Snackbar from '@mui/material/Snackbar';

function ListOfFiles() {
  const [buildsData, setBuildsData] = useState(null);
  const [databasesList, setDatabasesList] = useState(null);
  const [jsonData, setJsonData] = useState(null);
  const [downloadsData, setDownloadsData] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);

  const [firstFolderName, setFirstFolderName] = useState("");
  const [firstBuildFolderName, setFirstBuildFolderName] = useState("");
  const [firstDownloadFolderName, setFirstDownloadsFolderName] = useState("");

  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [openDoc, setOpenDoc] = useState(false);
  const [doc, setDoc] = useState("");
  const [loggedInUserRole,setloggedInUserRole] = useState("")
  const { userSessionRef} = useAuth();
  const INVERTIBLE_MANAGED_ORG = "invertible_managed";

  useEffect(() => {
    if (!userSessionRef) return;
    fetchListDataConnections();
    fetchListBuilds();
    fetchListDownloads();
    fetchListDatabases();
  }, [userSessionRef]);

  const fetchListDataConnections = async () => {
    try {
      let path = `/home/stateFiles/${userSessionRef.current["orgName"]}/${process.env.REACT_APP_ARCHITECTURE_NAME}/uploads`;
      if (userSessionRef.current["orgName"]==INVERTIBLE_MANAGED_ORG){
        //org2 = userSessionRef.current["orgName"] + "`" + userSessionRef.current["userName"];
         //const org = userSessionRef.current["orgName"] + "/users/" + userSessionRef.current["userName"].trim().replace(/^"+|"+$/g, '');
         path = `/home/stateFiles/${userSessionRef.current["orgName"]}/${process.env.REACT_APP_ARCHITECTURE_NAME}/uploads/` + userSessionRef.current["userName"].trim().replace(/^"+|"+$/g, '') +  "/uploads";
     }  
      
      const connectionsData = await listOfFileNamesPageDir(path);
      setJsonData(connectionsData);
      setFirstFolderName(connectionsData.info.name || "");
    } catch (error) {
      console.error("Error fetching connections:", error);
    }
  };

  const fetchListBuilds = async () => {
    try {
      const path = `/home/stateFiles/${userSessionRef.current["orgName"]}/${process.env.REACT_APP_ARCHITECTURE_NAME}/builds`;
      const buildsData = await listOfFileNamesPageDir(path);
      setBuildsData(buildsData);
      setFirstBuildFolderName(buildsData.info.name || "");
    } catch (error) {
      console.error("Error fetching builds:", error);
    } 
  };

  const fetchListDatabases = async () => {
    try {
      const path = `${process.env.REACT_APP_OMEGAPI_RUST_BACKEND_DIR}data_mount/` +  userSessionRef.current["orgName"] + "/databases";
      //const token = await fetchToken();
      const databasesResp= await listOfFileNamesPageDir(path);
      setDatabasesList(databasesResp);
      setFirstBuildFolderName(databasesResp.info.name || "");
    } catch (error) {
      console.error("Error fetching databases:", error);
    }
  };

  const fetchListDownloads = async () => {
    try {

      let  path = `${process.env.REACT_APP_OMEGAPI_RUST_BACKEND_DIR}data_mount/` + userSessionRef.current["orgName"] + "/output";
      if (userSessionRef.current["orgName"]==INVERTIBLE_MANAGED_ORG){
        //org2 = userSessionRef.current["orgName"] + "`" + userSessionRef.current["userName"];
         const org = userSessionRef.current["orgName"] + "/users/" + userSessionRef.current["userName"].trim().replace(/^"+|"+$/g, '');
         path = `${process.env.REACT_APP_OMEGAPI_RUST_BACKEND_DIR}data_mount/` + org  + "/output";
     }  
      //const token = await fetchToken();
      const downloadsData = await listOfFileNamesPageDir(path);
      setDownloadsData(downloadsData);
      setFirstDownloadsFolderName(downloadsData.info.name || "");
    } catch (error) {
      console.error("Error fetching downloads:", error);
    }
  };

  const uploadFilePathConnection = async (fileName) => {
    const user = userSessionRef.current["userName"].trim().replace(/^"+|"+$/g, '');
    try {
      const response = await uploadFilePath(
        fileName,
        userSessionRef.current["orgName"],
        user,
      );
  
      if (response.status === 200) {
        setIsPopupVisible(true);
        setSuccess("File uploaded successfully!");
      }
    } catch (error) {
      console.error("Error uploading file:", error);
      setError("Upload failed");
    }
  };

  const handleUpload = async () => {
    if (!selectedFile) return;
  
    setLoading(true);
    setSuccess("");
    setError("");
    let  MAX_SIZE = 1 * 1024 * 1024 * 1024;
    if (userSessionRef.current["orgName"]==INVERTIBLE_MANAGED_ORG) {
      MAX_SIZE = 200 * 1024 * 1024;
    }
  
    if (selectedFile.size > MAX_SIZE) {
      setError("File size exceeds 200MB limit");
      setLoading(false);
      return;
    }
  
    try {
      await uploadFilePathConnection(selectedFile);
      setSuccess("File uploaded successfully.Refresh page.");
    } catch (err) {
      setError("Upload failed");
    } finally {
      setLoading(false);
    }
  };


  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setSelectedFile(file);
  };

  const handleRefresh = () => {
    fetchListDataConnections();
    fetchListBuilds();
    fetchListDownloads();
    fetchListDatabases();
  };

  return (
    <div className="main-container">

      <Snackbar
      open={!!success}
      autoHideDuration={30000}
      onClose={() => setSuccess("")}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
    >
      <Alert severity="success" onClose={() => setSuccess("")}>
        {success}
      </Alert>
    </Snackbar>

    <Snackbar
      open={!!error}
      autoHideDuration={30000}
      onClose={() => setError("")}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
    >
      <Alert severity="error" onClose={() => setError("")}>
        {error}
      </Alert>
    </Snackbar>
    <Box sx={{ bgcolor: "#f5f9ff", minHeight: "100vh" }}>
    
    <Box sx={{ maxWidth: "960px", mx: "auto", py: 6, px: 3 }}>
      {/* === HEADER === */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 1,
        }}
      >
      </Box>
      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
      <Button
          variant="contained"
          color="primary"
          startIcon={<RefreshIcon />}
          onClick={handleRefresh}
          sx={{
            textTransform: "none",
            fontSize: "13px",
            borderRadius: "6px",
            paddingX: 1.5,
            paddingY: 0.75,
            mr: 1.5,
            mb:2,
            backgroundColor: "#2563eb"  
          }}
        >
          Refresh
      </Button>
      <InfoTip
        keyword="files_list"
        onLoad={(text) => {
          setDoc(text);
          setOpenDoc(true);
        }}
        />
        </div>

      {/* === UPLOAD PANEL === */}
      <Card
        elevation={0}
        sx={{
          borderRadius: 3,
          border: "1px solid #e3f2fd",
          mb: 4,
          backgroundColor: "white",
          boxShadow: "0 2px 8px rgba(25, 118, 210, 0.08)",
        }}
      >
        <CardContent sx={{ p: 4 }}>
          <Typography
            variant="h6"
            fontWeight={600}
            sx={{
              mb: 1.5,
              color: "#0a2540",
              fontFamily: "'Inter', 'Segoe UI', sans-serif",
            }}
          >
            Upload File
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
            Choose a file from your computer and upload it into your storage
            bucket.
          </Typography>

          <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
            <Input
              type="file"
              onChange={handleFileChange}
              sx={{
                border: "1px dashed #90caf9",
                borderRadius: 2,
                px: 2,
                py: 1,
                flex: 1,
              }}
            />
            <Button
              variant="contained"
              startIcon={<CloudUpload />}
              onClick={handleUpload}
              sx={{
                backgroundColor: "#2563eb",
                borderRadius: "10px",
                textTransform: "none",
                fontWeight: 500,
                fontFamily: "'Inter', 'Segoe UI', sans-serif",
                "&:hover": {
                        backgroundColor: "#1565c0",
                      },
              }}
            >
          {loading ? (
          <>
            <span className="spinner" /> Uploading..
          </>
        ) : (
          'Upload'
        )} 
            </Button>
          </Stack>

          {selectedFile && (
            <Paper
              variant="outlined"
              sx={{
                mt: 3,
                p: 2.5,
                borderRadius: 2,
                bgcolor: "#f8fbff",
                border: "1px solid #e3f2fd",
              }}
            >
              <Typography
                variant="subtitle2"
                sx={{
                  mb: 1,
                  color: "#0a2540",
                  fontFamily: "'Inter', 'Segoe UI', sans-serif",
                }}
              >
                Selected File Details
              </Typography>
              <Divider sx={{ mb: 1 }} />
              <Typography variant="body2">
                <strong>Name:</strong> {selectedFile.name}
              </Typography>
              <Typography variant="body2">
                <strong>Size:</strong> {selectedFile.size} bytes
              </Typography>
              <Typography variant="body2">
                <strong>Type:</strong> {selectedFile.type}
              </Typography>
              <Typography variant="body2">
                <strong>Last Modified:</strong>{" "}
                {new Date(selectedFile.lastModified).toLocaleDateString()}
              </Typography>
            </Paper>
          )}
        </CardContent>
      </Card>

      {/* === STACKED FILE SECTIONS === */}
      {[
        {  data: jsonData, firstFolder: firstFolderName },
        {  data: buildsData, firstFolder: firstBuildFolderName },
        {  data: downloadsData, firstFolder: firstDownloadFolderName },
        { data:  databasesList, firstFolder: firstDownloadFolderName },

      ].map((section, idx) => (
        <Card
          key={idx}
          elevation={0}
          sx={{
            borderRadius: 3,
            border: "1px solid #e3f2fd",
            mb: 4,
            backgroundColor: "white",
            boxShadow: "0 2px 8px rgba(25, 118, 210, 0.08)",
          }}
        >
          <Box
            sx={{
              background: "linear-gradient(90deg, #e3f2fd 0%, #f5f9ff 100%)",
              p: 2.5,
              display: "flex",
              alignItems: "center",
              gap: 1.5,
              borderTopLeftRadius: 12,
              borderTopRightRadius: 12,
              borderBottom: "1px solid #e0e7ef",
            }}
          >
            {section.icon}
            <Typography
              fontWeight={600}
              sx={{
                fontSize: "1rem",
                color: "#0a2540",
                fontFamily: "'Inter', 'Segoe UI', sans-serif",
              }}
            >
              {section.title}
            </Typography>
          </Box>
          <Box
            sx={{
              p: 3,
              overflowY: "auto",
              maxHeight: "60vh",
              background: "#f9fbff",
            }}
          >
            {section.data ? (
              <FileTree
                data={section.data}
                firstFolderName={section.firstFolder}
              />
            ) : (
              <CircularProgress size={24} />
            )}
          </Box>
        </Card>
      ))}
    </Box>
  </Box>

  <Drawer
  anchor="right"
  open={openDoc}
  onClose={() => setOpenDoc(false)}
>

  <div
    style={{
      width: "420px",
      height: "100%",
      display: "flex",
      flexDirection: "column"
    }}
  >

    {/* Header */}
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "12px 16px",
        borderBottom: "1px solid #ddd"
      }}
    >

      <strong>How to use features on this page?</strong>

      <IconButton onClick={() => setOpenDoc(false)}>
        <CloseIcon />
      </IconButton>

    </div>

    {/* Markdown Content */}
    <div
      style={{
        padding: "20px",
        overflowY: "auto",
        flex: 1
      }}
  >

  <ReactMarkdown
  components={{
    img: ({ node, ...props }) => (
      <img
        src={`/docs/${props.src}`}
        alt={props.alt}
        style={{
          maxWidth: "100%",
          borderRadius: "8px",
          marginTop: "12px",
        }}
      />
    ),
  }}
  >
  {doc}
  </ReactMarkdown>

  </div>

  </div>

</Drawer>

</div>

  );
}

export default ListOfFiles;
